module.exports = __webpack_public_path__ + "img/banner_bg@3x_PT.fa524c9a.png";